<div class="row">
  <div class="col-12 watchlist mt-3 mb-3 asset-search">
    <web-components-asset-search type="watchlist" (assetSelected)="newAssetSelected($event)" [isSmall]="false" [clearAfterSelect]="true" />
  </div>
  @if (errorMessage || (watchlistFacade.error$ | async); as backendError) {
    <div class="col-12 font-regular font-size-smaller1 mt-3 mt-sm-0 mb-3 text-color-error">{{ backendError ?? errorMessage }}</div>
  }
</div>
@if (watchlistSettings$ | async; as settings) {
  <div class="d-flex align-items-center">
    <web-components-position-filter [positions]="instrumentData" (filterChanged)="filter($event)" />
    <tags-dropdown type="watchlist" class="mr-2" />
    <button class="btn btn-toggle mr-2" [class.active]="settings.watchlistType === 'entry'" (click)="setType('entry')">
      {{ 'watchlist.settings.entry' | transloco }}
    </button>
    <button class="btn btn-toggle mr-2" [class.active]="settings.watchlistType === 'prev'" (click)="setType('prev')">
      {{ 'watchlist.settings.prev' | transloco }}
    </button>
    @if (watchlistFacade.hasNotes$ | async) {
      <button class="btn btn-toggle mr-2" [class.active]="settings.notesVisible" (click)="toggleNotes(settings)">
        {{ 'watchlist.settings.notes' | transloco }}
      </button>
    }
  </div>

  <div class="hidden-xl hidden-lg hidden-md">
    @if (compressed) {
      <ng-container
        [ngTemplateOutlet]="groupedItems ? groupedCompressedTable : compressedTable"
        [ngTemplateOutletContext]="{ compressedItems: watchlistViewModel }"
      />
      <ng-template #groupedCompressedTable>
        @for (item of groupedItems | keyvalue; track $index) {
          <h5 class="font-medium">{{ 'position-filter.' + item.key | transloco }}</h5>
          <hr class="less-margin" />
          <ng-container *ngTemplateOutlet="compressedTable; context: { compressedItems: item.value }" />
        }
      </ng-template>
      <ng-template #compressedTable let-compressedItems="compressedItems">
        <table class="table-compressed">
          <caption>
            Watchlist Compressed
          </caption>
          <thead>
            <th></th>
          </thead>
          <tbody>
            @for (item of compressedItems; track item.id) {
              <tr
                watchlist-item
                [item]="item"
                [compressed]="true"
                [performanceBasedOnEntry]="settings.watchlistType === 'entry'"
                [settings]="settings"
                [isEditEntryQuoteMode]="currentlyEditingEntryQuote !== undefined"
                [isCurrentlyEditing]="currentlyEditingEntryQuote === item.isin"
                (editNote)="currentlyEditingNote = { isin: item.isin, note: item.note }"
                (startEditingEntryQuote)="editEntryQuote(item.isin)"
                (updateEntryQuote)="updateEntryQuote($event)"
              ></tr>
            }
          </tbody>
        </table>
      </ng-template>
    }
  </div>

  <div [ngClass]="compressed ? 'hidden-xs hidden-sm' : ''">
    <ng-container [ngTemplateOutlet]="groupedItems ? groupedTable : table" [ngTemplateOutletContext]="{ items: watchlistViewModel }" />

    <ng-template #groupedTable>
      @for (item of groupedItems | keyvalue; track $index) {
        <h5 class="font-medium">{{ 'position-filter.' + item.key | transloco }}</h5>
        <hr class="less-margin" />
        <ng-container *ngTemplateOutlet="table; context: { items: item.value }" />
      }
    </ng-template>

    <ng-template #table let-items="items">
      <table class="table-depot table-watchlist" [class.light-opacity]="currentlyEditingEntryQuote">
        <caption>
          Watchlist
        </caption>
        <tbody>
          <tr>
            <th class="col-2">
              <web-components-sorter-label
                [sorter]="sorter"
                attr="longName"
                label="watchlist.labels.longName"
                direction="after"
                (click)="sortBy('longName')"
              />
              <br />
              <web-components-sorter-label
                [sorter]="sorter"
                attr="isin"
                label="watchlist.labels.isin"
                direction="after"
                (click)="sortBy('isin')"
              />
              <br />
              @if (settings.notesVisible && watchlistFacade.hasNotes$ | async) {
                <web-components-sorter-label
                  [sorter]="sorter"
                  attr="note"
                  label="watchlist.note"
                  direction="after"
                  (click)="sortBy('note')"
                />
              }
            </th>
            <th class="vertical-align-top" [class.ignore-opacity]="currentlyEditingEntryQuote">
              <web-components-sorter-label
                [sorter]="sorter"
                attr="ask"
                label="watchlist.labels.quote"
                direction="before"
                (click)="sortBy('ask')"
              />
              <br />
              @if (settings.watchlistType === 'entry') {
                <web-components-sorter-label
                  [sorter]="sorter"
                  attr="bidWhenAdded"
                  label="watchlist.labels.entry"
                  direction="before"
                  (click)="sortBy('bidWhenAdded')"
                />
              }
              @if (settings.watchlistType !== 'entry') {
                <web-components-sorter-label
                  [sorter]="sorter"
                  attr="calcBase"
                  label="watchlist.labels.prev"
                  direction="before"
                  (click)="sortBy('calcBase')"
                />
              }
            </th>
            <th class="vertical-align-top">
              <web-components-sorter-label
                [sorter]="sorter"
                attr="dayBeforePct"
                label="watchlist.labels.perf"
                direction="before"
                (click)="sortBy('dayBeforePct')"
              />
              <br />
              <web-components-sorter-label
                [sorter]="sorter"
                attr="dayBeforeAbs"
                label="watchlist.labels.perfAbsolut"
                direction="before"
                (click)="sortBy('dayBeforeAbs')"
              />
            </th>
            @if (settings.watchlistType === 'entry') {
              <th class="vertical-align-top">
                <web-components-sorter-label
                  [sorter]="sorter"
                  attr="perfPct"
                  label="watchlist.labels.perfPct"
                  direction="before"
                  (click)="sortBy('perfPct')"
                />
                <br />
                <web-components-sorter-label
                  [sorter]="sorter"
                  attr="perfAbs"
                  label="watchlist.labels.perfAbs"
                  direction="before"
                  (click)="sortBy('perfAbs')"
                />
              </th>
            }
            <th class="vertical-align-top">
              <web-components-sorter-label
                [sorter]="sorter"
                attr="quoteTime"
                label="watchlist.labels.quoteTime"
                direction="before"
                (click)="sortBy('quoteTime')"
              />
              <br />
              {{ 'watchlist.labels.date' | transloco }}
            </th>
            <th>&nbsp;</th>
          </tr>
          @if (!items?.length) {
            <tr>
              <td colspan="5">{{ 'watchlist.empty' | transloco }}</td>
            </tr>
          }
          @for (item of items; track item.id; let isFirst = $first, isLast = $last) {
            <tr
              watchlist-item
              [item]="item"
              [performanceBasedOnEntry]="settings.watchlistType === 'entry'"
              [settings]="settings"
              [class.no-border]="currentlyEditingNote?.isin === item.isin || (settings.notesVisible && item.note)"
              [isEditEntryQuoteMode]="currentlyEditingEntryQuote !== undefined"
              [isCurrentlyEditing]="currentlyEditingEntryQuote === item.isin"
              [isFirst]="isFirst"
              [isLast]="isLast"
              [isAddTagMode]="!!currentlyEditingTag"
              [isCurrentlyAddTagMode]="currentlyEditingTag === item.isin"
              (removeItem)="removeItem(item)"
              (up)="up(item)"
              (down)="down(item)"
              (editNote)="editNote(item.isin, item.note)"
              (editEntryQuote)="editEntryQuote(item.isin)"
              (updateEntryQuote)="updateEntryQuote($event)"
              (addTagMode)="currentlyEditingTag = item.isin"
              (cancelTagMode)="currentlyEditingTag = null"
            ></tr>
            @if (currentlyEditingNote?.isin === item.isin) {
              <tr>
                <td [attr.colspan]="currentlyEditingEntryQuote ? 5 : 6">
                  <div class="d-flex">
                    <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                    <div class="width-100">
                      <textarea
                        #noteTextArea
                        class="width-100"
                        maxlength="185"
                        [(ngModel)]="currentlyEditingNote.note"
                        (blur)="onSubmitNote(currentlyEditingNote.note, item.isin)"
                      ></textarea>
                      <div>{{ 'watchlist.note-label' | transloco }}</div>
                    </div>
                  </div>
                </td>
              </tr>
            } @else {
              @if (settings.notesVisible && item.note) {
                <tr>
                  <td [attr.colspan]="currentlyEditingEntryQuote ? 5 : 6">
                    <div class="d-sm-flex">
                      <div class="width-100 note" [innerHTML]="item.note | noteSafeHtml"></div>
                    </div>
                  </td>
                </tr>
              }
            }
            @if (item.isin === currentlyEditingTag) {
              <tr>
                <td colspan="8" class="ignore-opacity">
                  <tags-link-tag [entityId]="currentlyEditingTag" (cancelLinking)="currentlyEditingTag = null" />
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </ng-template>
  </div>
}
